import React, { useState } from 'react'
import { selectCompanies } from '@modules/admin/Admin.Dux'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { showAlert } from '../alert/Alert.dux'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import Customer from '@services/Customer'
import Input from '../../../adminv2/common/Input'
import Select from 'react-select'
import CompanyModal from '../../../adminv2/common/Modal'
import Alert from '../../../adminv2/common/Alert'
import _ from 'lodash'
import moment from 'moment'
import '../../../resources/assets/sass/admin/cruds/customer/styles.scss'

export default function CustomerCreateContainer() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const ageLimit = moment().subtract(18, 'years').format('YYYY-MM-DD')
  let history = useHistory()

  const initialFormValues = {
    vip: false,
    email: '',
    firstname: '',
    lastname: '',
    gender: '',
    birthdate: '',
    company_id: '',
    token: '',
    // has_videocall: false,
    // has_videocall_1to1: false,
    apiKey: '',
    secretKey: '',
    status: 2,
  }
  const [initialFormData] = useState(initialFormValues)
  const [formData, setFormData] = useState(initialFormValues)
  const companies = useSelector((state) => selectCompanies(state))
  const formattedCompanies = companies.map((company) => ({
    value: company.id,
    label: company.name,
    apiKey: company.api_key,
    secretKey: company.secret_key,
  }))
  const [showModal, setShowModal] = useState(false)

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 40,
      minHeight: 40,
    }),
  }

  const checkUnsavedChanges = () => {
    let isDirty = _.isEqual(formData, initialFormData)
    return isDirty
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    Customer.updateHeaders({ apiKey: formData.apiKey, secretKey: formData.secretKey })
    let formattedData = {
      ...formData,
      // has_videocall: formData.has_videocall ? 1 : 0,
      // has_videocall_1to1: formData.has_videocall_1to1 ? 1 : 0,
      vip: formData.vip ? 1 : 0,
    }

    Customer.customers
      .store(formattedData)
      .then(() => {
        dispatch(
          showAlert({
            text: `${t('generalCreateCustomerSuccessMessage')} ${formattedData.firstname} ${formattedData.lastname}`,
            important: '',
            type: 'success',
          })
        )
        history.push('/customers')
      })
      .catch((err) => {
        dispatch(
          showAlert({
            text: `${t('generalCreateErrorMessage')}`,
            important: '',
            type: 'danger',
          })
        )
      })
  }

  return (
    <div>
      {showModal ? (
        <CompanyModal
          close={() => setShowModal(false)}
          onCancel={() => setShowModal(false)}
          onSave={(e) => {
            document.getElementById('customer-create-form-submit').click()
            setShowModal(false)
          }}
          onReset={() => history.push('/customers')}
          title={t('integrationModalunsavedChangesTitle')}
          description={t('integrationModalunsavedChangesDescription')}
        />
      ) : null}
      <Alert timeOut={3000} />
      <DashboardHeader title={t('createUser')} />
      <div className="customer-create__header">
        <button
          className="btn btn-primary"
          onClick={() => (checkUnsavedChanges() ? history.goBack() : setShowModal(true))}
        >
          {t('back')}
        </button>
      </div>
      <form id="customer-create-form" onSubmit={handleSubmit}>
        <div className="md-form customer-create--container">
          <div className="customer-create--box">
            <h1>{t('Datos usuario')}</h1>
          </div>
          <div className="customer-create--box">
            <div className="form-group checkbox-modifier">
              <label>
                <input
                  type="checkbox"
                  id="vip"
                  value="vip"
                  onChange={(e) => setFormData({ ...formData, vip: e.target.checked })}
                />
                <span>{t('vipUser')}</span>
              </label>
            </div>
          </div>
          <Input
            wrapperclassname="customer-create--box"
            className="form-control"
            id="email"
            name="email"
            label={t('Email')}
            value={formData.email}
            required
            onChange={(value) => setFormData({ ...formData, email: value })}
            displayRequiredMark={false}
            type="email"
          />
          <Input
            wrapperclassname="customer-create--box"
            className="form-control"
            id="firstname"
            name="firstname"
            label={t('Nombre')}
            value={formData.firstname}
            required
            onChange={(value) => setFormData({ ...formData, firstname: value })}
            displayRequiredMark={false}
          />
          <Input
            wrapperclassname="customer-create--box"
            className="form-control"
            id="lastname"
            name="lastname"
            label={t('lastName')}
            value={formData.lastname}
            required
            onChange={(value) => setFormData({ ...formData, lastname: value })}
            displayRequiredMark={false}
          />
          <div className="customer-create--box">
            <div className="form-group">
              <label>{t('Género')}</label>
              <Select
                options={[
                  { value: 0, label: t('Hombre') },
                  { value: 1, label: t('Mujer') },
                ]}
                name="gender"
                onChange={(option) => setFormData({ ...formData, gender: option.value })}
                styles={customStyles}
                placeholder={t('Género')}
                required
              />
            </div>
          </div>
          <Input
            wrapperclassname="customer-create--box"
            className="form-control"
            id="birthdate"
            name="birthdate"
            label={t('Fecha de nacimiento')}
            type="date"
            onChange={(value) => {
              let inputDateFormatted = moment(value, 'YYYY-MM-DD')
              let differenceInYears = moment().diff(inputDateFormatted, 'years', true)
              if (differenceInYears >= 18) setFormData({ ...formData, birthdate: value })
            }}
            max={ageLimit}
            required
            displayRequiredMark={false}
          />
          <div className="customer-create--box">
            <div className="form-group">
              <label>{t('Compañía')}</label>
              <Select
                options={formattedCompanies}
                styles={customStyles}
                required
                placeholder={t('Compañía')}
                name="company_id"
                onChange={(option) =>
                  setFormData({
                    ...formData,
                    company_id: option.value,
                    apiKey: option.apiKey,
                    secretKey: option.secretKey,
                  })
                }
              />
            </div>
          </div>
          <Input
            wrapperclassname="customer-create--box--full"
            className="form-control"
            id="token"
            name="token"
            label="Token"
            value={formData.token}
            required
            onChange={(value) => setFormData({ ...formData, token: value })}
            displayRequiredMark={false}
          />
          {/* <div className="customer-create--box">
            <div className="form-group checkbox-modifier">
              <label>
                <input
                  type="checkbox"
                  id="hasVideoCallCheck"
                  value="hasVideoCall"
                  checked={formData.has_videocall}
                  onChange={(e) => setFormData({ ...formData, has_videocall: e.target.checked })}
                />
                <span>{t('hasVideocall')}</span>
              </label>
              <label>
                <input
                  type="checkbox"
                  id="hasVideoCall1to1Check"
                  value="hasVideoCall1to1"
                  checked={formData.has_videocall_1to1}
                  onChange={(e) => setFormData({ ...formData, has_videocall_1to1: e.target.checked })}
                />
                <span>{t('hasVideocall1to1')}</span>
              </label>
            </div>
          </div> */}
        </div>
      </form>
      <div className="customer-create__footer">
        <button
          className="btn btn-primary"
          type="submit"
          form="customer-create-form"
          id="customer-create-form-submit"
          disabled={checkUnsavedChanges()}
        >
          {t('save')}
        </button>
        <button
          className="btn btn-outline-primary"
          onClick={() => (checkUnsavedChanges() ? history.push('/customers') : setShowModal(true))}
        >
          {t('cancel')}
        </button>
      </div>
    </div>
  )
}
